import React from "react";
import { useState, useEffect } from "react";
import AuthService from "../services/auth.service";
import api from "../services/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import TopBar from "../components/TopBar";
import { useLocation } from "react-router-dom";
import { describe } from "../constants/diseases";

function Disease() {
  const [disease, setDisease] = useState({});
  const [calf, setCalf] = useState({});
  const navigate = useNavigate();
  let { calfId, id } = useParams();
  const getCalf = () => {
    api.get("/calfs/" + calfId)
      .then((response) => {
        const data = response.data;
        setCalf(data);
      })
      .catch((error) => {
        console.error("There was an error getting a calf!", error);
      });
  };
  const getDisease = () => {
    api.get("/health/" + id)
      .then((response) => {
        const data = response.data;
        setDisease(data);
      })
      .catch((error) => {
        console.error("There was an error creating a calf!", error);
      });
  };
  const handleDelete = () => {
    api.delete("/health/" + id)
      .then(() => {
        navigate("/veaux/" + calfId + "?view=health");
      })
      .catch((error) => {
        console.error("There was an error creating a calf!", error);
      });
  };
  useEffect(() => {
    //Runs only on the first render
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) {
      navigate("/login");
    } else {
      getDisease();
      getCalf();
    }
  }, []);
  return (
    <div>
      <TopBar link={"/veaux/" + calfId + "?view=health"}></TopBar>
      <div className="flex md:w-[800px] mb-3 ml-3">
        <div className="flex justify-center items-center px-3 py-1 bg-stone-200/60 dark:bg-slate-700/50 rounded-lg">
          <Link to="/">
            <span className="font-semibold text-stone-700 dark:text-slate-300 text-sm">
              Mes Veaux
            </span>
          </Link>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-4 h-4 text-stone-300 mr-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 4.5l7.5 7.5-7.5 7.5"
            />
          </svg>
          <Link to={"/veaux/" + calfId + "?view=health"}>
            <span className=" font-semibold text-stone-700 dark:text-slate-300 text-sm">
              {calf.name}
            </span>
          </Link>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-4 h-4 text-stone-300 mr-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 4.5l7.5 7.5-7.5 7.5"
            />
          </svg>
          <span className="text-stone-400 text-sm">
            {new Date(disease.start_date).toLocaleString("default", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </span>
        </div>
      </div>
      <div className="bg-white dark:bg-slate-800 rounded-lg mt-3 mx-3">
        <div className="flex flex-col ml-3">
          <div className="flex justify-between items-center border-b dark:border-slate-700">
            <span className="py-2 text-sm text-stone-600 dark:text-slate-300">Date de début</span>
            <span className="text-stone-400 text-sm mr-3">
              {new Date(disease.start_date).toLocaleString("default", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
          <div className="flex justify-between items-center border-b dark:border-slate-700">
            <span className="py-2 text-sm text-stone-600 dark:text-slate-300">Date de fin</span>
            <span className="text-stone-400 text-sm mr-3">
              {disease.end_date === null
                ? ""
                : new Date(disease.end_date).toLocaleString("default", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
            </span>
          </div>
          <div className="flex justify-between items-center border-b dark:border-slate-700">
            <span className="py-2 text-sm text-stone-600 dark:text-slate-300">Maladie</span>
            <span className="text-stone-400 text-sm mr-3">{describe(disease)}</span>
          </div>
          <div className="flex flex-col justify-start items-start border-b dark:border-slate-700">
            <span className="py-2 text-sm text-stone-600 dark:text-slate-300">Traitement</span>
            <p className="text-stone-400 text-sm mr-3 mb-3">{disease.treatment}</p>
          </div>
          <div className="flex justify-between items-center border-b dark:border-slate-700">
            <span className="py-2 text-sm text-stone-600 dark:text-slate-300">Veterinaire requis</span>
            <span className="text-stone-400 text-sm mr-3">{disease.veterinary_required ? "Oui" : "Non"}</span>
          </div>
          <div className="flex justify-between items-center border-b dark:border-slate-700">
            <span className="py-2 text-sm text-stone-600 dark:text-slate-300">Antibiotiques requis</span>
            <span className="text-stone-400 text-sm mr-3">{disease.antibiotics_required ? "Oui" : "Non"}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="py-2 text-sm text-stone-600 dark:text-slate-300">Anti-inflammatoires requis</span>
            <span className="text-stone-400 text-sm mr-3">{disease.antiinflammatory_required ? "Oui" : "Non"}</span>
          </div>
        </div>
      </div>
      <div className="px-3 mt-3">
        <Link to={"/modifier_maladie/" + calfId + "/" + id}>
          <button className="bg-amber-400 dark:bg-amber-600 rounded-lg text-white shadow font-semibold py-2 w-full">
            Modifier
          </button>
        </Link>
      </div>
      <div className="px-3 mt-3">
        <button
          className="bg-white border border-stone-300 dark:border-red-700 dark:bg-red-600 dark:text-white rounded-lg text-red-500 shadow font-semibold py-2 w-full"
          onClick={() => handleDelete()}
        >
          Supprimer
        </button>
      </div>
    </div>
  );
}

export default Disease;
